const configurationKeys = {
  index: "configuration",
};

export const getConfigurationKey = () => {
  return [configurationKeys.index];
};
